import axios from 'axios';

const API_BASE = subscriptionApi+'addons'; // Base URL for addon endpoints

export default {
    // Addon endpoints
    getAllAddons() {
        return axios.get(`${API_BASE}`);
    },
    
    createAddon(addon) {
        return axios.post(`${API_BASE}`, addon);
    },
    
    getAddonById(id) {
        return axios.get(`${API_BASE}/${id}`);
    },
    
    updateAddon(id, addon) {
        return axios.put(`${API_BASE}/${id}`, addon);
    },
    
    deleteAddon(id) {
        return axios.delete(`${API_BASE}/${id}`);
    },
    
    // Product Addon endpoints
    getAddonsByProductId(productId) {
        return axios.get(`${API_BASE}/product/${productId}`);
    },
    
    addAddonToProduct(productId, addonId) {
        return axios.post(`${API_BASE}/product/${productId}/addon/${addonId}`);
    },
    
    removeAddonFromProduct(productId, addonId) {
        return axios.delete(`${API_BASE}/product/${productId}/addon/${addonId}`);
    },
    
    // Store Addon endpoints
    getAddonsByStoreId(storeId) {
        return axios.get(`${API_BASE}/store/${storeId}`);
    },
    
    addAddonToStore(storeId, addonId) {
        return axios.post(`${API_BASE}/store/${storeId}/addon/${addonId}`);
    },
    
    removeAddonFromStore(storeId, addonId) {
        return axios.delete(`${API_BASE}/store/${storeId}/addon/${addonId}`);
    },
    
    // Product Addons query endpoint
    getAddonsByProductIdQuery(productId) {
        return axios.get(`/api/product-addons?productId=${productId}`);
    }
};